import request from '@/utils/request3'
import store from '@/store'
import qs from 'qs'
const serviceName = store.state.serviceName.workOrder

// 销售资金池信息
export function getFundPoolList(data) {
    return request({
        url: serviceName + `/fund/fund_pool_list?` + qs.stringify(data),
        method: 'get',
    })
}

// 录入各类费用列表
export function getVariousList(data) {
    return request({
        url: serviceName + `/fund/various_list?` + qs.stringify(data),
        method: 'get',
    })
}

// 录入各类费用
export function addVarious(data) {
    return request({
        url: serviceName + `/fund/various_add`,
        method: 'post',
        data: data
    })
}

// 删除费用
export function deleteVarious(data) {
    return request({
        url: serviceName + `/fund/various_delete`,
        method: 'post',
        data: data
    })
}

// 修改费用
export function editVarious(data) {
    return request({
        url: serviceName + `/fund/various_update`,
        method: 'post',
        data: data
    })
}

// 复核费用记录
export function checkVarious(data) {
    return request({
        url: serviceName + `/fund/various_check`,
        method: 'post',
        data: data
    })
}

// 获取项目资金转接列表
export function getTransferProjectList(data) {
    return request({
        url: serviceName + `/fund/transfer_project_list?` + qs.stringify(data),
        method: 'get',
    })
}

// 查询项目采购明细
export function getProjectBuyList(data) {
    return request({
        url: serviceName + `/fund/project_buy_list?` + qs.stringify(data),
        method: 'get',
    })
}

// 查询项目费用明细
export function getProjectCostList(data) {
    return request({
        url: serviceName + `/fund/project_cost_list?` + qs.stringify(data),
        method: 'get',
    })
}

// 快递运单费用表Excel数据导入
export function importWaybillExcel(data) {
    return request({
        url: serviceName + `/fund/waybill_cost_excel`,
        method: 'post',
        data: data
    })
}

// 办公费用表Excel数据导入
export function importOfficeExcel(data) {
    return request({
        url: serviceName + `/fund/office_cost_excel`,
        method: 'post',
        data: data
    })
}

// 快递运单费用仓库表查询
export function getWaybillCostList(data) {
    return request({
        url: serviceName + `/fund/waybill_cost_store_list?` + qs.stringify(data),
        method: 'get',
    })
}

// 快递运单费用删除
export function deleteWaybillCostStore(data) {
    return request({
        url: serviceName + `/fund/waybill_cost_store_delete`,
        method: 'post',
        data: data
    })
}

// 快递运单费用修改
export function updateWaybillCostStore(data) {
    return request({
        url: serviceName + `/fund/waybill_cost_store_update`,
        method: 'post',
        data: data
    })
}


// 办公打印费用列表
export function getOfficeCostStore(data) {
    return request({
        url: serviceName + `/fund/tb_office_cost_store_list?` + qs.stringify(data),
        method: 'get',
    })
}

// 修改办公打印费用
export function updateOfficeCostStore(data) {
    return request({
        url: serviceName + `/fund/tb_office_cost_store_update`,
        method: 'post',
        data: data
    })
}

// 修改办公打印费用
export function deleteOfficeCostStore(data) {
    return request({
        url: serviceName + `/fund/tb_office_cost_store_delete`,
        method: 'post',
        data: data
    })
}

// 确认快递运费
export function confirmWaybillCostStore(data) {
    return request({
        url: serviceName + `/fund/waybill_cost_store_confirm`,
        method: 'post',
        data: data
    })
}

// 确认办公费
export function confirmOfficeCostStore(data) {
    return request({
        url: serviceName + `/fund/tb_office_cost_store_confirm`,
        method: 'post',
        data: data
    })
}

// 确认办公费
export function batCheckVarious(data) {
    return request({
        url: serviceName + `/fund/various_check_bat`,
        method: 'post',
        data: data
    })
}


